import type { Store } from '../types/location.types';

/**
 * Convert a store name to a URL-friendly slug.
 * e.g. "Furtastic Melbourne" → "furtastic-melbourne"
 */
export const slugifyStoreName = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Find a store whose slugified name matches the given slug.
 */
export const findStoreBySlug = (stores: Store[], slug: string): Store | undefined => {
  return stores.find(store => slugifyStoreName(store.name) === slug);
};

/**
 * Build a booking URL with the store slug appended.
 * e.g. getBookingUrl('services', store) → "/book/services/furtastic-melbourne"
 * Falls back to "/book/services" when no store is provided.
 */
export const getBookingUrl = (step: string, store: Store | null, queryString?: string): string => {
  const slug = store ? slugifyStoreName(store.name) : '';
  const base = slug ? `/book/${step}/${slug}` : `/book/${step}`;
  return queryString ? `${base}?${queryString}` : base;
};
